import React, { useEffect, useContext } from 'react';

import { AppContext } from '../../../RoutesWithAuth';

import { Link, useLocation, useNavigate } from 'react-router-dom';

import axios from '../../common/AxiosConfig';

import AppBar from "@mui/material/AppBar";

import Toolbar from "@mui/material/Toolbar";

import Typography from "@mui/material/Typography";

import Box from "@mui/material/Box";

import Tab from "@mui/material/Tab";

import Tabs from "@mui/material/Tabs";
import { makeStyles } from "@mui/styles";

import Breadcrumbs from '@mui/material/Breadcrumbs';

import IconButton from '@mui/material/IconButton';

import DateRangeIcon from '@mui/icons-material/DateRange';

import ErrorIcon from '@mui/icons-material/Error';

import MenuItem from '@mui/material/MenuItem';

import { signOut } from '../../common/AuthHelper';

import { v2UIRoutePath } from '../../common/commons';

import { ChevronRight } from '@mui/icons-material';

import { Popover, Snackbar, Tooltip } from '@mui/material';

import { Alert } from '@mui/lab';

import AlertIcon from './AlertIcon';
import PreferencesModal from './PreferencesModal';


const useStyles = makeStyles(() => ({
  '@global': {
    "html": {
      fontSize: '93%'
    },
    '& .MuiCheckbox-colorPrimary.Mui-checked': {
      color: '#7f9ed7'
    }
  },
  appBar: {
    boxShadow: '0 0.125rem 0.25rem rgb(0 0 0 / 8%)'
  },
  appBarLogo: {
    marginRight: 10,
    height: 35
  },
  toolbar: {
    backgroundColor: "#000000",
    "&": {
      minHeight: "40px"
    }
  },
  breadcrumbToolbar: {
    backgroundColor: "#ffffff",
    borderBottom: '1px solid #e2e8f0',
    "&": {
      minHeight: "42px",
      padding: '5px 20px',
    },
    "& a": {
      color: "#475569",
      fontSize: '1rem',
      fontWeight: 500,
      textDecoration: 'none',
      transition: 'color 0.2s ease',
      '&:hover': {
        color: '#267db7',
      },
    },
    '& .MuiBreadcrumbs-separator': {
      color: '#94a3b8',
    },
  },

  tabs: {
    '& .MuiTabs-indicator': {
      height: '4px',
      transform: "scale(0.6,1)"
    }
  },
  tab: {
    fontFamily: 'revert',
    color: "#f7f7f7",
    fontSize: "revert",
    textTransform: 'none',
    '&.Mui-selected.MuiTab-textColorInherit': {
      opacity: 1,
    },
    '&.MuiTab-textColorInherit': {
      opacity: 0.7
    },
    "&.Mui-selected": {
      color: "#f7f7f7"
    }
  },
  popovermenuclass: {
    '& .MuiPopover-paper': {
      minWidth: '200px',
      width: 'auto',
      maxWidth: '300px',
      padding: '10px 0px'
    },
    '& .MuiMenuItem-root': {
      padding: '5px 15px',
      fontSize: '0.875rem'
    }
  },
  tabWithDropDown: {
    "& .MuiTab-wrapper": {
      display: "flow-root",
      "&::after": {
        display: "inline-block",
        width: 0,
        height: 0,
        marginLeft: "10px",
        verticalAlign: ".255em",
        content: '""',
        borderTop: ".3em solid",
        borderRight: ".3em solid transparent",
        borderBottom: "0",
        borderLeft: ".3em solid transparent"
      }
    }
  }
}
));

const activeLinks = [
  ["Home", v2UIRoutePath, [{
    name: "Request Details View",
    samepath: true
  }]],
  ["Tracking", v2UIRoutePath + "tracking"],
  ["Reports", v2UIRoutePath + "reports"],
  ["Resources", v2UIRoutePath + "resources"],
  ["Admin", v2UIRoutePath +"admin"]
]
function Navbar(props) {
  const navigate = useNavigate();
  const location = useLocation();
  const classes = useStyles();
  const [value, setValue] = React.useState(props.activeIndex);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [prefsOpen, setPrefsOpen] = React.useState(false);
  const [requestHealth, setRequestHealth] = React.useState({});
  const [reportHealth, setReportHealth] = React.useState({});
  const [displayError, setDisplayError] = React.useState(false);
  const [ticker, setTicker] = React.useState('');

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };
  const handleChange = (event, newValue) => {
    if (newValue === 5) {
      return;
    }
    setValue(newValue);
  };
  const context = useContext(AppContext)
  const authToken = context.authToken.get
  const userName = context.userName.get
  const email = context.email.get
  const isAdmin = context.isAdmin.get
  const reloadHealth = context.reloadHealth.get

  const cachedHealth = React.useCallback(() => {
    getRequestHealth();
    getReportHealth();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  },[location?.pathname, reloadHealth]);

  useEffect(() => {
    return cachedHealth(location?.pathname, reloadHealth);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  },[location?.pathname, reloadHealth])

  const getReportHealth = () => {
    axios.get("reports/health_report", {
      headers: {
        Authorization: authToken
      }
    }).then(res => {
      let totalReportsHealthConsolidated = {};
      let viewLink = v2UIRoutePath + "reports/errorreport";
      if (res.data?.downstream) {
        totalReportsHealthConsolidated = res.data?.downstream
      }
      if (res.data?.upstream) {
        Object.keys(res.data?.upstream).forEach((_total_key) => {
          if (!totalReportsHealthConsolidated[_total_key]) {
            totalReportsHealthConsolidated[_total_key] = 0;
          }
          if(res.data?.upstream[_total_key] !== 0){
            viewLink = v2UIRoutePath + "reports/errorreport/upstream";
          }
          totalReportsHealthConsolidated[_total_key] += res.data?.upstream[_total_key];
        })
      }
      let displayErrorIcon = false;
      Object.keys(totalReportsHealthConsolidated).forEach((_key) => {
        if (totalReportsHealthConsolidated[_key] !== 0) {
          displayErrorIcon = true;
        }
      })
      setReportHealth({
        ...totalReportsHealthConsolidated,
        displayErrorIcon,
        viewLink
      });
      setTicker(res.data.ticker)
    })
  }

  const getRequestHealth = () => {
    axios.get("reports/request_health", {
      headers: {
        Authorization: authToken
      }
    }).then(res => {
      setRequestHealth(res.data);
    })
  }

  // Environment variables - fallback to default if not set
  const buildDate = (typeof process !== 'undefined' && process.env?.REACT_APP_BUILD_DATE) || "00-00-00";
  const displayVersion = ` ${((typeof process !== 'undefined' && process.env?.REACT_APP_VERSION) || 'Dev').split('-')[0].replace(/v/g, "")} (${buildDate})`;

  const getDateRangeColor = (calender_comment) => {
    const days = parseInt(calender_comment.split("taking").pop().split("days")[0]);
    if (days <= 3) {
      return "#267db7"
    } else if (days <= 7) {
      return "#ffc000"
    } else if (days > 7) {
      return "#eb0a1e"
    }
  }

  const handleErrorClose = () => {
    setDisplayError(false);
  }
  return (

    <Box sx={{ flexGrow: 1 }}>
      <AppBar className={classes.appBar} position="static">
        <Toolbar className={classes.toolbar}>
          <Link to="/">
            <span className={classes.appBarLogo}>
              <img src="/CT_logo.png" height="38" alt={"logo"} />
            </span>
          </Link>
          <Typography
            variant="h6"
            noWrap
            component="div"
            sx={{ display: { xs: "none", sm: "block" } }}
          >
            Consumer Privacy System
          </Typography>
          <Box sx={{ flexGrow: 1 }} />
          <Box sx={{ display: { md: "flex" } }}>
            <Tabs
              className={classes.tabs}
              value={value}
              onChange={handleChange}
              aria-label="nav tabs example"
            >
              <Tab className={classes.tab} component="span" onClick={(event) => { event.preventDefault(); navigate(v2UIRoutePath) }} label="HOME" />
              <Tab className={classes.tab} component="span" onClick={(event) => { event.preventDefault(); navigate(v2UIRoutePath + "tracking") }} label="TRACKING" href="/trash" />
              <Tab className={classes.tab} component="span" onClick={(event) => { event.preventDefault(); navigate(v2UIRoutePath + "reports") }} label="REPORTS" href="/spam" />
              <Tab className={classes.tab} component="span" onClick={(event) => { event.preventDefault(); navigate(v2UIRoutePath + "resources") }} label="RESOURCES" />
              <Tab className={classes.tab} component="span" onClick={(event) => { event.preventDefault(); navigate("/admin") }} label="ADMIN" />
              <Tab className={`${classes.tabWithDropDown} ${classes.tab}`} component="span" onClick={(event) => { handleClick(event); event.preventDefault(); }} label={userName} href="/spam" />
            </Tabs>
          </Box>
        </Toolbar>
        <Toolbar className={classes.breadcrumbToolbar}>
          <Breadcrumbs aria-label="breadcrumb" separator={(<ChevronRight fontSize='small' />)}>
            <Link 
              color="secondary" 
              to={activeLinks[value][1]}
              state={{
                fromBreadCrumb: Math.round(Math.random() * 1e5),
                ...(location?.state || {}),
                allowReset: location?.state ? false : true
              }}
            >
              {activeLinks[value][0]}
            </Link>
            {props.subTabIndex > 0 && activeLinks[value][2] && (
              <Link 
                color="secondary" 
                to={activeLinks[value][1]}
                state={{ 
                  fromBreadCrumb: Math.round(Math.random() * 1e5)
                }}
              >
                {activeLinks[value][2][props.subTabIndex - 1].name}
              </Link>
            )}
          </Breadcrumbs>

         <Box sx={{ flexGrow: 1, marginLeft: 4, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          {ticker && (
            <Box
              sx={{
                display: 'inline-flex',
                alignItems: 'center',
                gap: '8px',
                background: 'rgba(220, 38, 38, 0.08)',
                border: '1px solid rgba(220, 38, 38, 0.25)',
                borderRadius: '6px',
                padding: '4px 14px',
                maxWidth: '100%',
                animation: 'flash-banner 1.5s ease-in-out infinite',
                '@keyframes flash-banner': {
                  '0%, 100%': { 
                    background: 'rgba(220, 38, 38, 0.08)', 
                    borderColor: 'rgba(220, 38, 38, 0.25)',
                    boxShadow: 'none',
                  },
                  '50%': { 
                    background: 'rgba(220, 38, 38, 0.25)', 
                    borderColor: 'rgba(220, 38, 38, 0.6)',
                    boxShadow: '0 0 12px rgba(220, 38, 38, 0.3)',
                  },
                },
              }}
            >
              <Box
                sx={{
                  width: 9,
                  height: 9,
                  borderRadius: '50%',
                  backgroundColor: '#dc2626',
                  flexShrink: 0,
                  boxShadow: '0 0 6px rgba(220, 38, 38, 0.6)',
                  animation: 'pulse-dot 1.5s ease-in-out infinite',
                  '@keyframes pulse-dot': {
                    '0%, 100%': { 
                      opacity: 1, 
                      transform: 'scale(1)', 
                      boxShadow: '0 0 6px rgba(220, 38, 38, 0.6)',
                      backgroundColor: '#dc2626',
                    },
                    '50%': { 
                      opacity: 0.3, 
                      transform: 'scale(1.6)', 
                      boxShadow: '0 0 16px rgba(220, 38, 38, 0.9)',
                      backgroundColor: '#ef4444',
                    },
                  },
                }}
              />
              <Typography
                noWrap
                component="span"
                sx={{
                  fontSize: '0.78rem',
                  fontWeight: 600,
                  color: '#dc2626',
                  letterSpacing: '0.15px',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                }}
                title={ticker}
              >
                {ticker}
              </Typography>
            </Box>
          )}
          </Box>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
            <AlertIcon requestHealth={requestHealth} />
            {requestHealth?.calender_comment && (
              <Tooltip title={requestHealth?.calender_comment} arrow>
                <IconButton
                  size="small"
                  onClick={() => {
                    navigate(v2UIRoutePath + "reports/requestsagingreport");
                  }}
                  sx={{
                    width: 34,
                    height: 34,
                    borderRadius: '8px',
                    transition: 'all 0.2s ease',
                    '&:hover': {
                      backgroundColor: 'rgba(0,0,0,0.06)',
                      transform: 'translateY(-1px)',
                    },
                  }}
                >
                  <DateRangeIcon sx={{
                    fontSize: '1.2rem',
                    color: getDateRangeColor(requestHealth.calender_comment),
                  }} />
                </IconButton>
              </Tooltip>
            )}
            <Tooltip title={reportHealth?.displayErrorIcon ? "System errors detected" : "All systems operational"} arrow>
              <IconButton
                size="small"
                onClick={() => {
                  setDisplayError(true)
                }}
                sx={{
                  width: 34,
                  height: 34,
                  borderRadius: '8px',
                  transition: 'all 0.2s ease',
                  '&:hover': {
                    backgroundColor: 'rgba(0,0,0,0.06)',
                    transform: 'translateY(-1px)',
                  },
                }}
              >
                <ErrorIcon sx={{ fontSize: '1.2rem', color: reportHealth?.displayErrorIcon ? "#eb0a1e" : "#16a34a" }} />
              </IconButton>
            </Tooltip>
          </Box>
        </Toolbar>
      </AppBar>
      {displayError && (
        <Snackbar anchorOrigin={{ vertical: 'top', horizontal: 'right' }} open={!!displayError} autoHideDuration={6000} onClose={handleErrorClose}>
          <Alert 
            onClose={handleErrorClose} 
            severity={reportHealth?.displayErrorIcon ? "error" : "success"}
            sx={{ 
              minWidth: '380px',
              '& .MuiAlert-message': { width: '100%' },
              backgroundColor: reportHealth?.displayErrorIcon ? '#fdeded' : '#edf7ed',
              color: reportHealth?.displayErrorIcon ? '#5f2120' : '#1e4620'
            }}
          >
            {reportHealth?.displayErrorIcon ? (
            <Box>
              <Box display="flex" justifyContent="space-between" alignItems="center" marginBottom="16px">
                <Box>
                  <Box fontWeight="700" fontSize="15px" color="#d32f2f">Upload Failed</Box>
                  <Box fontSize="11px" color="#666" marginTop="2px">
                    CPS was unable to process/upload requests
                  </Box>
                </Box>
              </Box>
              
              <Box 
                display="grid" 
                gridTemplateColumns="repeat(2, 1fr)" 
                gap="6px"
                sx={{
                  '& > div': {
                    display: 'flex',
                    justifyContent: 'space-between',
                    padding: '6px 10px',
                    backgroundColor: '#fff',
                    borderRadius: '4px',
                    fontSize: '12px',
                    border: '1px solid #f5c6cb'
                  }
                }}
              >
                <Box>
                  <span style={{ color: '#666' }}>AWL</span>
                  <strong style={{ color: reportHealth?.awl > 0 ? '#d32f2f' : '#666' }}>
                    {reportHealth?.awl || "0"}
                  </strong>
                </Box>
                <Box>
                  <span style={{ color: '#666' }}>ISR</span>
                  <strong style={{ color: reportHealth?.isr > 0 ? '#d32f2f' : '#666' }}>
                    {reportHealth?.isr || "0"}
                  </strong>
                </Box>
                 <Box>
                  <span style={{ color: '#666' }}>RTC</span>
                  <strong style={{ color: reportHealth?.rtc > 0 ? '#d32f2f' : '#666' }}>
                    {reportHealth?.rtc || "0"}
                  </strong>
                </Box>
                <Box>
                  <span style={{ color: '#666' }}>RTD</span>
                  <strong style={{ color: reportHealth?.rtd > 0 ? '#d32f2f' : '#666' }}>
                    {reportHealth?.rtd || "0"}
                  </strong>
                </Box>
                <Box>
                  <span style={{ color: '#666' }}>RTK</span>
                  <strong style={{ color: reportHealth?.rtk > 0 ? '#d32f2f' : '#666' }}>
                    {reportHealth?.rtk || "0"}
                  </strong>
                </Box>
                 <Box>
                  <span style={{ color: '#666' }}>RTO</span>
                  <strong style={{ color: reportHealth?.rtoo > 0 ? '#d32f2f' : '#666' }}>
                    {reportHealth?.rtoo || "0"}
                  </strong>
                </Box>
                <Box>
                  <span style={{ color: '#666' }}>RTT</span>
                  <strong style={{ color: reportHealth?.rtt > 0 ? '#d32f2f' : '#666' }}>
                    {reportHealth?.rtt || "0"}
                  </strong>
                </Box>
                <Box>
                  <span style={{ color: '#666' }}>RWL</span>
                  <strong style={{ color: reportHealth?.rwl > 0 ? '#d32f2f' : '#666' }}>
                    {reportHealth?.rwl || "0"}
                  </strong>
                </Box>
                <Box>
                  <span style={{ color: '#666' }}>TVLA</span>
                  <strong style={{ color: reportHealth?.tvla > 0 ? '#d32f2f' : '#666' }}>
                    {reportHealth?.tvla || "0"}
                  </strong>
                </Box>
                <Box>
                  <span style={{ color: '#666' }}>UFV</span>
                  <strong style={{ color: reportHealth?.ufv > 0 ? '#d32f2f' : '#666' }}>
                    {reportHealth?.ufv || "0"}
                  </strong>
                </Box>
              </Box>

              <Box 
                marginTop="12px" 
                textAlign="right"
              >
                <Box
                  component="span"
                  onClick={() => {
                    handleErrorClose();
                    navigate(reportHealth.viewLink);
                  }}
                  sx={{
                    color: '#d32f2f',
                    fontSize: '12px',
                    fontWeight: '600',
                    cursor: 'pointer',
                    '&:hover': {
                      color: '#b71c1c'
                    }
                  }}
                >
                  View Details →
                </Box>
              </Box>
            </Box>
            ) : (
            <Box>
              <Box fontWeight="700" fontSize="15px" color="#2e7d32">All Systems Operational</Box>
              <Box fontSize="12px" color="#1e4620" marginTop="8px">
                No failed uploads. All requests are being processed successfully.
              </Box>
            </Box>
            )}
          </Alert>
        </Snackbar>
      )}
      <Popover
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleClose}
        className={classes.popovermenuclass}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
      >
        <MenuItem >Email : {email}</MenuItem>
        <MenuItem >Role : {isAdmin ? "Admin" : "User"}</MenuItem>
        <MenuItem onClick={() => { handleClose(); setPrefsOpen(true); }}>Preferences</MenuItem>
        <MenuItem onClick={() => window.open("/centra/", '_blank', 'noopener,noreferrer')}>Centra</MenuItem>
        <MenuItem >Version : {displayVersion}</MenuItem>
        <MenuItem onClick={() => signOut(context)}> Sign Out</MenuItem>

      </Popover>
      <PreferencesModal open={prefsOpen} onClose={() => setPrefsOpen(false)} />
    </Box>

  )
}
export const withNavbar = (ComponentToWrap, activeIndex = 0, subTabIndex = 0) => {
  return (props) => (
    <div className='navWrapper'>
      <Navbar activeIndex={activeIndex} subTabIndex={subTabIndex} />

      <div id="body-container" className="d-flex flex-column">
        <div className="wrapper flex-grow-1" style={{ height: '100%' }}>
          <ComponentToWrap {...props} />
        </div>
      </div>

    </div>
  )
}

export default React.memo(Navbar);
